export const unstable_settings = {
  initialRouteName: '(tabs)',
};

export { default } from 'navigation/layouts/root-layout';
